import * as yup from 'yup';

const validationSchema = yup.object().shape({
  lang: yup.string().required('Required'),
  template: yup.string().required('Required'),
  message: yup.string().required('Required'),
});

export default validationSchema;
